function PageContainer({
  children,
  customClass = "",
  childrenCustomClass = "",
  isMobileView,
}) {
  const isHome = window.location.pathname === "/home";

  return (
    <div
      className={`w-full h-full flex justify-center items-start ${customClass}`}
    >
      <div
        className={`
          w-full max-w-4xl
          bg-white dark:bg-black
          text-foreground
          ${isHome
            ? "rounded-none sm:rounded-lg md:rounded-xl"
            : "rounded-none sm:rounded-lg md:rounded-xl"}
          ${isMobileView ? "pb-10" : ""}
          flex flex-col
          min-h-full
          overflow-hidden
        `}
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div
          className={`
            p-2 sm:p-6 md:p-8 
            pt-9
            relative
            flex-1
            w-full
            h-full
            min-w-0
            ${childrenCustomClass}
          `}
        >
          <div className="pb-4 px-2 w-full">{children}</div>
        </div>
      </div>

      <style jsx>{`
        div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}

export default PageContainer;
